import { fetcher } from "../../utils/fetcher.js";

export const createBoard = (boardData) => {
  return fetcher.post("/api/boards", boardData);
};
